import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import {publicBuildUrl} from "../../../config/config";
import Modal from "../../Modal";

const Buik = () => (
    <Modal title={'DE MELDCODE ALS HULPCODE'}
           image={'https://care-free.app/wp-content/uploads/2024/01/Hoowy_Buik_RolloverActive.png'}>
        <div>
            <p>
                Wanneer er zorgen zijn <b>helpt de meldcode</b> in 5 stappen om een juiste afweging te maken. De
                Meldcode doorlopen betekent niet vanzelfsprekend dat er een melding gemaakt moet worden. Het helpt je om
                een <b>afweging te maken</b>: is <b>melden</b> wel of niet noodzakelijk?
            </p>

            <p>
                Wanneer je besluit dat een melding noodzakelijk is omdat je <b>een vermoeden hebt van acute en/of
                structurele onveiligheid</b> doe je dit omdat je <b>de ander gunt</b> dat er <b>hulp komt</b> in de
                situatie en jij deze hulp niet kunt bieden vanuit <b>de rol</b> die je hebt.
            </p>

            <p>
                De Meldcode als ‘Hulpcode’ met daarin de uitwerking van de 5 stappen kun je <a className={'download'}
                                                                                               href={"https://care-free.app/wp-content/uploads/2024/01/Hand-out-Meldcode-als-Hulpcode.pdf"}
                                                                                               target={'_blank'}>hier</a> downloaden. <b>Met
                de Meldcode als ‘Hulpcode’ maken we samen het verschil!</b>
            </p>

            <h2>
                VEILIG THUIS
            </h2>

            <p>
                Veilig Thuis is er <b>voor advies en ondersteuning en het melden van huiselijk geweld en
                kindermishandeling.</b> Voor jezelf, maar ook als je je zorgen maakt over de veiligheid van iemand
                anders kun je een beroep doen op Veilig Thuis; ook als professional. Of je nu vermoedens hebt, of het
                zeker weet. Je zorgen delen is een belangrijke eerste stap.
            </p>

            <p>
                Als je belt met Veilig Thuis krijg je een medewerker aan de lijn, die aandachtig naar je verhaal
                luistert. Deze medewerker zet samen met je alles op een rij, <b>beantwoordt vragen en geeft advies</b>.
                Als nodig kijkt hij of zij samen met jou welke <b>hulp</b> er nodig is.
            </p>

            <p>
                <b>
                    Je kunt anoniem de situatie bespreekbaar maken en advies vragen.<br/>
                    Je kunt als professional niet anoniem melden, tenzij er sprake is van onveiligheid voor de melder.
                </b>
            </p>

            <p>
                <img
                    src={'https://care-free.app/wp-content/uploads/2024/01/veilig-thuis-logo234x.png'}
                    alt='veilig thuis'
                    style={{
                        maxWidth: "80px",
                    }}
                />
            </p>
            <p>
                <b>Wil je contact leggen met Veilig Thuis voor advies en/of melden?</b><br/>Bel gratis (24/7) naar
                0800-2000.<br/>
                <a href={'https://veiligthuis.nl/'} target={'_blank'}>www.veiligthuis.nl</a>
            </p>

            <h2>
                CENTRUM SEKSUEEL GEWELD
            </h2>
            <p>
                Als professional kun je te maken krijgen met situaties waarin sprake is van <b>seksueel geweld/misbruik.
                Heb je hulp nodig, twijfel je of zit je met vragen?</b> Dan kun je altijd <b>anoniem en gratis
                contact</b> opnemen met het Centrum Seksueel Geweld.
            </p>

            <p>
                <img
                    src={'https://care-free.app/wp-content/uploads/2024/01/CSG-logo-groot.png'}
                    alt='Centrum Seksueel Geweld'
                    style={{
                        maxWidth: "80px",
                    }}
                />
            </p>

            <p>
                Je kunt <b>bellen</b> naar <b>0800-0188</b>.<br/>
                Je kunt ook <b>chatten</b> of het <b>contactformulier</b> van het centrum seksueel geweld invullen via
                de <b>website</b>: <a href={'https://www.centrumseksueelgeweld.nl'}
                                      target={'_blank'}>www.centrumseksueelgeweld.nl</a>
            </p>

            <h2>
                LANDELIJK EXPERTISE CENTRUM EER GERELATEERD GEWELD
            </h2>
            <p>
                Als professional kun je te maken krijgen met situaties waarin sprake is van <b>Eer Gerelateerd Geweld. Heb je hulp nodig, twijfel je of zit je met vragen?</b> Dan kun je contact opnemen met het Landelijke Expertise Centrum Eer Gerelateerd Geweld (LEC EGG)
            </p>

            <p>
                <img
                    src={'https://care-free.app/wp-content/uploads/2024/01/2560px-Logo_politie.svg_.png'}
                    alt={'Politie'}
                    style={{
                        maxWidth: "80px",
                    }}/>
            </p>

            <p>
                Je kunt <b>bellen</b> naar <b>088-9648550</b>.<br/>
                <b>Meer informatie:</b> <a
                href={'https://www.politie.nl/informatie/contactpersonen-lec-egg-bij-de-politie.html'}
                target={"_blank"}>www.politie.nl/informatie/contactpersonen-lec-egg-bij-de-politie.html
            </a>
            </p>
        </div>
    </Modal>
);

export default Buik;
